import axios from 'axios'
import * as CONFIG from '../config/index'
import * as helper from './helper'
export const AZURE_API_URL = `${CONFIG.API_URL}/process-login/azureAd`

export const loginAzure = async (code) => {
  try {
    let result = await axios.get(`${AZURE_API_URL}?code=${code}`);
    return result.data.data;
  } catch (e) {
    helper.notifyError(e);
    return null;
  }
}

export const logoutAzure = async () => {
  try {
    await axios.get(CONFIG.LOGOUT_URL);
  } catch (e) {
    console.error(e);
  }
}

export default {
  loginAzure: loginAzure,
  logoutAzure: logoutAzure
}



// WEBPACK FOOTER //
// ./src/common/azureCommon.js